import { Paper ,Box, useTheme, Button, Typography, Divider, skeletonClasses } from "@mui/material";
import { tokens } from "../../theme";
import ResumeSectionKitPayment from "./resume-section-kit-payment";
import { useEffect, useState } from "react";
import SkeletonTable from "./resume-section-kit-payment-skeleton";

import { djangoApi } from "../../utils/axios/axios.utils";
import KitComissionPage from "./resume-section-kit-comission";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import VoucherModalForm from "./resume-section-kit-voucher";
import SkeletonVoucherTable from "./resume-section-kit-payment-voucher-skeleton";


const ResumeSectionKit = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { dataToEdit, totalSoldProdsValue, valueForComission, formType, valueForComissionVeludos, valueForComissionSacolas, dataToShow, setDataToShow, seller, setDataCheckPayment } = props

    const [isLoading, setIsLoading] = useState(false);

    const [isLoadingVoucher, setIsLoadingVoucher] = useState(false);
    const [voucherData, setVoucherData] = useState([]);

    const [totalPaidToPitaya, setTotalPaidToPitaya] = useState(0);

    const [showModal, setShowModal] = useState(false);
    
    const [data, setData] = useState({});

    useEffect(() => {
        setDataCheckPayment(data)
    }, [data, setDataCheckPayment]);

    function formatDateToBrazilian(dateString) {
        if (!dateString) return ""; // Handle empty or null inputs
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    }

    const getVoucherKit = async () => {
        setIsLoadingVoucher(true)
        try {
            const response = await djangoApi
                .get(`products/kit_voucher/${dataToEdit.kit_pk}/get_kit_vouchers/`, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            const data = {
                data: response?.data?.data,
                status: response.status
            }
            setVoucherData(data?.data)
            return
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoadingVoucher(false)
        } finally {
            // pass
            setIsLoadingVoucher(false)
        }
    };

    useEffect(() => {
        const getVoucherKit = async () => {
            setIsLoadingVoucher(true)
            try {
                const response = await djangoApi
                    .get(`products/kit_voucher/${dataToEdit.kit_pk}/get_kit_vouchers/`, {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                const data = {
                    data: response?.data?.data,
                    status: response.status
                }
                setVoucherData(data?.data)
                return
            } catch (err) {
                console.log("Erro ao alterar as aplicações", err);
                window.alert(err);
                setIsLoadingVoucher(false)
            } finally {
                // pass
                setIsLoadingVoucher(false)
            }
        };
        if (voucherData.length === 0) {
            getVoucherKit()
        }
    }, []);

    const getKitPayments = async () => {
        setIsLoading(true)
        try {
            const response = await djangoApi
                .get(`products/kit_payment/${dataToEdit.kit_pk}/get_kit_payments/`, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            if (response?.data?.data?.length > 0) {
                const newData = response?.data?.data?.map((data) => {
                    return ({
                        pk: data.id,
                        value: Number(data.paid_value),
                        date: formatDateToBrazilian(data.date_pay),
                        payment_method: data.payment_method,
                        obs: data.obs

                    })
                })
                setDataToShow(newData)
                const data = {
                    data: response?.data?.data,
                    status: response.status
                }
                return data
            } else {
                setDataToShow([])
            }
        } catch (err) {
            console.log("Erro ao pegar os dados", err);
            window.alert(err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    };

    useEffect(() => {
        const getKitPayments = async () => {
            setIsLoading(true)
            try {
                const response = await djangoApi
                    .get(`products/kit_payment/${dataToEdit.kit_pk}/get_kit_payments/`, {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                if (response?.data?.data?.length > 0) {
                    const newData = response?.data?.data?.map((data) => {
                        return ({
                            pk: data.id,
                            value: Number(data.paid_value),
                            date: formatDateToBrazilian(data.date_pay),
                            payment_method: data.payment_method,
                            obs: data.obs

                        })
                    })
                    setDataToShow(newData)
                    const data = {
                        data: response?.data?.data,
                        status: response.status
                    }
                    return data
                } else {
                    console.log('lista Vazia')
                    setDataToShow([])
                }
            } catch (err) {
                console.log("Erro ao pegar os dados", err);
                window.alert(err);
                setIsLoading(false)
            } finally {
                // pass
                setIsLoading(false)
            }
        };
        if (dataToEdit?.kit_pk) {
            getKitPayments();
        }
        getKitPayments()
    }, [dataToEdit]);


    const handleAddVoucher = () => {
        setShowModal(!showModal)
    }

    return (
        <>

            <VoucherModalForm
                dataToEdit={dataToEdit}
                showModal={showModal}
                setShowModal={setShowModal}
                setVoucherData={setVoucherData}
            />
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'auto auto 783px auto',
                    justifyContent: 'flex-start',
                    width: '1240px',
                    minHeight: '350px',
                }}
            >
                <Box
                    sx={{
                        // maxHeight: '350px',
                        // overflow: 'auto',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        // alignItems: 'center'
                    }}
                >
                    {
                        isLoadingVoucher ?
                            <SkeletonVoucherTable />
                            :
                            <KitComissionPage
                                totalSoldProdsValue={totalSoldProdsValue}
                                totalPaidToPitaya={totalPaidToPitaya}
                                valueForComission={valueForComission}
                                formType={formType}
                                valueForComissionVeludos={valueForComissionVeludos}
                                valueForComissionSacolas={valueForComissionSacolas}
                                voucherData={voucherData}
                                setVoucherData={setVoucherData}
                                data={data}
                                setData={setData}
                            />
                    }
                </Box>

                <Divider orientation="vertical" sx={{ width: '2px', height: '100%', margin: '0px 10px' }} />
                <Box
                component={Paper}
                elevation={8}
                    sx={{
                        // maxHeight: '350px',
                        overflow: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        // alignItems: 'center'
                    }}
                >
                    {
                        isLoading ?
                            <SkeletonTable />
                            :

                            <ResumeSectionKitPayment
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                dataToEdit={dataToEdit}
                                dataToShow={dataToShow}
                                getKitPayments={getKitPayments}
                                setTotalPaidToPitaya={setTotalPaidToPitaya}
                                resumePaymentData={data}
                                seller={seller}
                            />
                    }
                </Box>
                <Divider orientation="vertical" sx={{ width: '2px', height: '100%', margin: '0px 10px' }} />
                <Box mt={2}>
                    <Button
                        startIcon={<AddCircleIcon size={24} color="inherit" />}
                        size="small"
                        color="success"
                        onClick={handleAddVoucher}
                        sx={{ borderRadius: '6px', color: 'whitesmoke' }}
                        variant="contained"
                    >
                        Voucher
                    </Button>
                </Box>
            </Box>
        </>
    );
}

export default ResumeSectionKit;